// Alérgenos (14 de declaración obligatoria UE) y etiquetas de producto

export const ALLERGENS = [
  { id: "gluten", label: "Gluten", icon: "🌾" },
  { id: "crustacis", label: "Crustacis", icon: "🦞" },
  { id: "ous", label: "Ous", icon: "🥚" },
  { id: "peix", label: "Peix", icon: "🐟" },
  { id: "cacauets", label: "Cacauets", icon: "🥜" },
  { id: "soja", label: "Soja", icon: "🫘" },
  { id: "lactics", label: "Làctics", icon: "🥛" },
  { id: "fruits-secs", label: "Fruits secs", icon: "🌰" },
  { id: "api", label: "Api", icon: "🌿" },
  { id: "mostassa", label: "Mostassa", icon: "🟡" },
  { id: "sesam", label: "Sèsam", icon: "⚪" },
  { id: "sulfits", label: "Sulfits", icon: "🍇" },
  { id: "tramussos", label: "Tramussos", icon: "🌱" },
  { id: "molluscs", label: "Mol·luscs", icon: "🐚" },
];

export const ALLERGEN_LABEL = Object.fromEntries(ALLERGENS.map((a) => [a.id, a.label]));
export const ALLERGEN_ICON = Object.fromEntries(ALLERGENS.map((a) => [a.id, a.icon]));

export const TAGS = [
  { id: "nou", label: "Nou", className: "bg-emerald-500/85 text-white border-emerald-400/70 shadow-lg shadow-emerald-500/30" },
  { id: "popular", label: "Popular", className: "bg-primary/90 text-primary-foreground border-primary/60 shadow-lg shadow-primary/40" },
  { id: "temporada", label: "Especial de Temporada", className: "bg-fuchsia-500/90 text-white border-fuchsia-400/70 shadow-lg shadow-fuchsia-500/40" },
];

export const TAG_MAP = Object.fromEntries(TAGS.map((t) => [t.id, t]));
